export default "__VITE_ASSET__D_nVREy1__"